<script setup>
import { Link, useForm } from '@inertiajs/vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import HotelSubMenu from '@/Includes/HotelSubMenu.vue';
import Swal from 'sweetalert2';
import { useToast } from 'vue-toast-notification';
import Loading from 'vue-loading-overlay';
import { ref, onMounted } from "vue";
import { Modal } from 'bootstrap';

const props = defineProps({
    year: String,
    ageRanges: Object,
    hotelsById: Object,
    flash: Object,
    user: Object,
});

const $toast = useToast();
let isLoading = ref(false);
let modalShow = ref(null);
let thisModalObj = null;
let menu = 'ageranges';

onMounted(() => {
    thisModalObj = new Modal(modalShow.value);
});

const AgeRangeAddform = useForm({
    type: null,
    max_age: null,
    hotel_id: props.hotelsById.id,
});

const AgeRangeAddformSubmit = () => {
    AgeRangeAddform.post('/agerange/store', {
        preserveScroll: true,
        onStart: () => isLoading.value = true,
        onFinish: () => isLoading.value = false,
        onSuccess: () => {
            thisModalObj.hide(),
                $toast.open({
                    message: props.flash.message,
                    type: "info",
                    duration: 4000,
                    position: 'top-right',
                    class: 'bs-toast toast bg-dark show'
                });
        }
    });
};

function deleteAgeRanges(value) {
    new Swal({
        title: 'Are you sure?',
        text: "All the data related to this object will be deleted!",
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        confirmButtonText: 'I am sure!'
    }).then((result) => {
        if (result.isConfirmed) {
            setTimeout(() => {
                window.location.href = '/agerange/delete/' + value;
            }, 300);

            $toast.success('Age range deleted successfully!', {
                position: 'top-right',
                duration: 4000,
                hideProgressBar: true,
                icon: true,
                type: "info",
                class: 'bs-toast toast bg-dark show'
            });
        }
    })
}

const FormReset = () => {
    AgeRangeAddform.reset();
    AgeRangeAddform.clearErrors();
};

</script>
<style scoped>
@import "../../../../public/ui/vendor/libs/toastr/toastr.css";
@import "vue-loading-overlay/dist/vue-loading.css";
@import "sweetalert2/dist/sweetalert2.min.css";
</style>

<template>
    <AppLayout title="Hotel Age Ranges" :year=year :user=user>
        <div class="vld-parent">
            <Loading v-model:active="isLoading" :color="'#696cff'" />
        </div>
        <div class="container-xxl flex-grow-1 container-p-y">
            <HotelSubMenu :hotelsById="hotelsById" :menu="menu" />
            <div class="row g-0">
                <div class="card">
                    <h5 class="card-header">Hotel Age Ranges</h5>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6 mt-5 mt-md-0">
                                <div class="added-cards">
                                    <div class="bg-lighter rounded-2 p-3 mb-3" v-for="(ages, index) in ageRanges"
                                        :key="ages.id" style="border: 1px solid #8592a3;">
                                        <div class="d-flex justify-content-between flex-sm-row flex-column">
                                            <div class="card-information me-2">
                                                <div class="d-flex align-items-center mb-1 flex-wrap gap-2">
                                                    <h6 class="mb-0 me-2">{{ ages.type }}</h6>
                                                </div>
                                                <p>Max Age: <span
                                                        class="badge bg-label-primary rounded-pill text-uppercase">{{
                                                            ages.max_age
                                                        }} Years</span></p>
                                            </div>
                                            <div class="d-flex flex-column text-start text-sm-end"
                                                v-if="$page.props.user.permissions.includes('remove-age-ranges')">
                                                <div class="d-flex order-sm-0 order-1 mt-sm-0 mt-3">
                                                    <Link class="btn btn-label-secondary" href="#"
                                                        @click="deleteAgeRanges(ages.id)" preserve-scroll replace>Delete
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6 mt-5 mt-md-0">
                                <div class="text-center mt-4 mx-3 mx-md-0">
                                    <img src="/ui/img/illustrations/agerange.jpg" class="img-fluid" alt="meals"
                                        width="300">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="addAgeModal" tabindex="-1" aria-modal="true" role="dialog" ref="modalShow">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add Age Range</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <hr>
                    <form @submit.prevent="AgeRangeAddformSubmit">
                        <div class="modal-body">
                            <div class="row">
                                <div class="col mb-3">
                                    <label for="name" class="form-label"><b>Type</b></label>
                                    <select class="form-select" name="type" v-model="AgeRangeAddform.type"
                                        :class="{ 'is-invalid': AgeRangeAddform.errors.type }">
                                        <option disabled="disabled" selected="selected">Select type ...</option>
                                        <option value="infant">Infant</option>
                                        <option value="child">Child</option>
                                    </select>
                                    <div v-if="AgeRangeAddform.errors.type" class="invalid-feedback">
                                        <div v-text="AgeRangeAddform.errors.type">
                                        </div>
                                    </div>
                                </div>
                                <div class="col mb-3">
                                    <label for="name" class="form-label"><b>Max Age</b></label>
                                    <select class="form-select" name="max_age" v-model="AgeRangeAddform.max_age"
                                        :class="{ 'is-invalid': AgeRangeAddform.errors.max_age }">
                                        <option disabled="disabled" selected="selected">Select age ...</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                        <option value="12">12</option>
                                        <option value="13">13</option>
                                        <option value="14">14</option>
                                        <option value="15">15</option>
                                        <option value="16">16</option>
                                        <option value="17">17</option>
                                        <option value="18">18</option>
                                        <option value="19">19</option>
                                        <option value="20">20</option>
                                    </select>
                                    <div v-if="AgeRangeAddform.errors.max_age" class="invalid-feedback">
                                        <div v-text="AgeRangeAddform.errors.max_age">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-label-secondary" data-bs-dismiss="modal"
                                @click="FormReset">
                                Close
                            </button>
                            <button type="submit" class="btn btn-primary">Add</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </AppLayout>
</template>